// Backend configurations, voice models and transcribe models are either public (no organization) or private
// to one organization. A project can only use the public ones and those of its own organization.
export const isAvailableForOrganization = (item, organizationId) =>
  !item?.organizationId || item.organizationId === organizationId;

export const filterByOrganization = (items, organizationId) =>
  (items || []).filter(item => isAvailableForOrganization(item, organizationId));
